import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        <section className="bg-gradient-to-b from-primary-50 to-white">
        <div className="container-width py-12 md:py-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
        <h1 className="text-4xl md:text-5xl font-light text-primary-900 mb-6">
        Cloud <span className="font-normal">Migration</span>
        <span className="block">
        <span className="font-light">Made</span> <span className="font-normal text-red-900">Simple</span>
        </span>
        </h1>
        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
        Expert tenant-to-tenant migration services with zero downtime,
        complete data integrity, comprehensive business continuity planning with advanced project management.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/contact" className="btn-primary text-center">
        Get Free Assessment
        </Link>
        <Link to="/services" className="btn-secondary text-center">
        View Our Services
        </Link>
        </div>
        </div>
        <div className="hidden md:block">
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-8 shadow-sm">
        <div className="space-y-3">
        <div className="bg-white h-3 rounded w-3/4 shadow-sm"></div>
        <div className="bg-white h-3 rounded w-full shadow-sm"></div>
        <div className="bg-white h-3 rounded w-2/3 shadow-sm"></div>
        </div>
        </div>
        </div>
        </div>
        </div>
        </section>
    );
};

export default Hero;
